import { firstReadableBlock, isReadableBlock } from './content';
import type {Anchor,ContentPackage,UserState} from './types';
export function migrateState(state:UserState,content:ContentPackage):UserState {
 const resolve=(anchor:Anchor):Anchor=>{
  const direct=content.blocks.find(b=>b.id===anchor.blockId);
  if(direct && anchor.textHash===direct.textHash && (anchor.language==='en'?direct.enText:direct.ruText).slice(anchor.start,anchor.end)===anchor.exactQuote) return {...anchor,textHash:direct.textHash,status:'resolved'};
  const mapping=content.migration?.mappings.find(m=>m.oldId===anchor.blockId);
  const matches=content.blocks.filter(b=>b.id===anchor.blockId||mapping?.newIds.includes(b.id)).flatMap(b=>{
   const text=anchor.language==='en'?b.enText:b.ruText;
   const quote=anchor.exactQuote;
   const start=text.indexOf(quote);
   if(!quote||start<0||text.indexOf(quote,start+1)>=0)return [];
   return [{...anchor,blockId:b.id,start,end:start+quote.length,prefix:text.slice(Math.max(0,start-32),start),suffix:text.slice(start+quote.length,start+quote.length+32),textHash:b.textHash,status:'resolved' as const}];
  });
  return matches.length===1?matches[0]:{...anchor,status:'orphaned'};
 };
 const annotations=state.annotations.map(a=>{const fragments=a.anchor.fragments?.map(resolve);const first=fragments?.[0];return {...a,anchor:first?{...a.anchor,blockId:first.blockId,language:first.language,start:first.start,end:first.end,prefix:first.prefix,suffix:first.suffix,textHash:first.textHash,fragments,status:fragments!.every(f=>f.status==='resolved')?'resolved' as const:'orphaned' as const}:resolve(a.anchor)};});
 const vocabulary=state.vocabulary.map(v=>({...v,anchor:resolve(v.anchor)}));
 const bookmarks=state.bookmarks.map(bookmark=>{
   const mapping=content.migration?.mappings.find(m=>m.oldId===bookmark.blockId);
   const id=content.blocks.some(b=>b.id===bookmark.blockId)?bookmark.blockId:mapping?.newIds.length===1?mapping.newIds[0]:null;
   const block=content.blocks.find(b=>b.id===id);
   return block?{...bookmark,blockId:block.id,pageNumber:block.sourceRefs[0].pdfPageNumber,status:'resolved' as const}:{...bookmark,status:'orphaned' as const};
 });
 const pos=state.readingPosition;
  const mapped=content.migration?.mappings.find(m=>m.oldId===pos.blockId);
  const newId=content.blocks.some(b=>b.id===pos.blockId)?pos.blockId:mapped?.newIds.length===1?mapped.newIds[0]:null;
  const newBlock=content.blocks.find(b=>b.id===newId);
 const fallback=firstReadableBlock(content);
 const positionBlock=newBlock && isReadableBlock(content,newBlock)?newBlock:fallback;
 const positionIsReadable=Boolean(newBlock && isReadableBlock(content,newBlock));
 const nextPosition={
  ...pos,
  blockId:positionBlock?.id??null,
  sectionId:positionBlock?.sectionId??'section-1',
  pageNumber:positionBlock?.sourceRefs[0]?.pdfPageNumber??13,
  offset:positionIsReadable?pos.offset:0,
  representation:'original' as const,
  contentVersion:content.contentVersion,
 };
 const visitedSectionIds=[...new Set(state.readingProgress.visitedSectionIds.map(id=>id==='chapter-01'?'section-1':id))];
 return {...state,annotations,vocabulary,bookmarks,settings:{...state.settings,mode:'original',repeatOriginal:false},readingProgress:{...state.readingProgress,visitedSectionIds},readingPosition:nextPosition};
}
